module.exports = __webpack_public_path__ + "img/markitoLogo.ac97fba6.png";